export const nameKeyDown = {
	data() {
		return {
			nameKeyDown: ''
		}
	},
	beforeMount() {
		window.addEventListener("keydown", this.onKeyDown)
	},
	beforeUnmount() {
		window.removeEventListener('keydown', this.onKeyDown)
	},
	methods: {
		onKeyDown(event) {
			EventBus.$emit('on_key_down_name', event.key);
		}
	}
}
